import { UseQueryResult, useQuery } from "@tanstack/react-query";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { getRecoil, setRecoil } from "recoil-nexus";
import styled from "styled-components";
import AddCardModal from "../../components/modal/AddCardModal";
import AuthenticationModal from "../../components/modal/AuthenticationModal";
import CardListModal from "../../components/modal/CardListModal";
import ConfirmModal from "../../components/modal/ConfirmModal";
import CustomerInfoModal from "../../components/modal/CustomerInfoModal";
import ApiController from "../../controller/ApiController";
import LogController from "../../controller/LogController";
import { EventType } from "../../controller/MasterController";
import MessageController from "../../controller/MessageController";
import OrderController, {
  CARD_METHOD,
  CARD_NAME_JBC,
  CARD_NAME_MASTER,
  CARD_NAME_UNION,
  CARD_NAME_VISA,
  FOREIGN_METHOD,
  PG_METHOD,
  StoreOrderType,
  cardType,
} from "../../controller/OrderController";
import { useToast } from "../../controller/ToastController";
import {
  authStoreType,
  masterStoreState,
  qrAuthState,
  qrAuthType,
} from "../../recoil/auth";
import {
  cartPayInfo,
  cartPayInfoState,
  cartProductQuantityState,
  cartState,
} from "../../recoil/cart";
import { eventState } from "../../recoil/event";
import {
  LANG_CH,
  LANG_EN,
  LANG_JP,
  LANG_KO,
  LANG_TH,
  langState,
  langText,
} from "../../recoil/lang";
import {
  CouponType,
  PRODUCT_TYPE_DELIVERY,
  PRODUCT_TYPE_RENTAL_SMS,
  orderDetailRealmType,
} from "../../recoil/type";
import "../../styles/CustomModal.css";
import AsyncLocalStorage from "../../utils/AsyncLocalStorage";
import {
  getOptionName,
  getOptionTypeName,
  getPrdName,
  getProductName,
} from "../../utils/util";

let addedListeners: any = {};
let oWindow: Window | null = null;

const Payment = () => {
  const showToast = useToast();
  const navigate = useNavigate();

  const lang = useRecoilValue<number>(langState);
  const auth = useRecoilValue<qrAuthType>(qrAuthState);

  const location = useLocation();
  const storeName = location.state?.storeName;

  const cart = useRecoilValue<orderDetailRealmType[]>(cartState);
  const cartPay = useRecoilValue<cartPayInfo>(cartPayInfoState);
  const cartQuantitiy = useRecoilValue<number>(cartProductQuantityState);
  const [visibleConfirm, setVisibleConfirm] = useState<boolean>(false);
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);
  const [onKeyboard, setOnKeyboard] = useState<boolean>(false);

  const [requestChecked1, setRequestChecked1] = useState<boolean>(true);
  const [requestChecked2, setRequestChecked2] = useState<boolean>(true);
  const [requestText, setRequestText] = useState<string>("");
  // const [requestText, setRequestText] = useState<string>("");
  const master = useRecoilValue<authStoreType>(masterStoreState);
  const [orderInfo, setOrderInfo] = useState<StoreOrderType>({
    address1: "",
    address2: "",
    area_number: 0,
    number: 0,
    area_name: "",
    name: "",
    store_id: 0,
    limit_order_price: 0,
    max_delivery_distance: "",
    base_delivery_price: 0,
    base_delivery_distance: "",
    surcharge_delivery_distance: 0,
    surcharge_delivery_price: 0,
    is_self_delivery: 0,
    delivery_call_type: 0,
    delivery_estimated_time: 0,
    delivery_prepare_time: 0,
    pickup_name: "",
    pickup_name_en: "",
    store_login_yn: true,
    next_open_time: "",
    next_close_time: "",
    store_availability_yn: true,
    store_availability: "",
    room_tip: 0,
    coupon_list: {
      availble_coupon_list: [],
      unavailable_coupon_list: [],
    },
  });

  const [isOrder, setIsOrder] = useState<boolean>(false);
  const [couponCode, setCouponCode] = useState<string>("");

  //실제 사용가능 쿠폰
  const [couponList, setCouponList] = useState<CouponType[]>([]);
  //고객에게 보여지는 쿠폰
  const [visibleCouponList, setVisibleCouponList] = useState<CouponType[]>([]);
  //고객에게 보여지는 쿠폰
  const [unavailableCouponList, setUnavailableCouponList] = useState<
    CouponType[]
  >([]);

  // 인증 모달
  const [visibleAuthentication, setVisibleAuthentication] =
    useState<boolean>(false);
  const [visibleCardList, setVisibleCardList] = useState<boolean>(false);
  const [visibleAddCard, setVisibleAddCard] = useState<boolean>(false);

  const [visibleClosed, setVisibleClosed] = useState<boolean>(false);

  const [visibleCustomerInfoModal, setVisibleCustomerInfoModal] = useState<{
    visible: boolean;
    method: number;
    card_name?: string;
  }>({ visible: false, method: 1 });

  const [discount, setDiscount] = useState<{
    discountAmount: number;
    storeDiscountAmount: number;
    hqDiscountAmount: number;
    storeDiscountList: { description: string; discount: number }[];
    hqDiscountList: { description: string; discount: number }[];
    couponList: (CouponType & {
      store_discount_amount: number;
      com_discount_amount: number;
    })[];
  }>({
    discountAmount: 0,
    hqDiscountAmount: 0,
    storeDiscountAmount: 0,
    storeDiscountList: [],
    hqDiscountList: [],
    couponList: [],
  });

  const [selectedCard, setSelectedCard] = useState<number>(-1);

  const cardList: UseQueryResult<cardType[]> = useQuery({
    queryKey: ["card-list"],
    queryFn: () => ApiController.user.getCard(auth.client_user_id),
  });

  const [orderResult, setOrderResult] = useState<any>();

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [realPayPrice, setRealPayPrice] = useState<number>(
    cart.length > 0 && cart[0].product_type === PRODUCT_TYPE_DELIVERY
      ? cartPay.total_amount_incl -
          discount.discountAmount +
          orderInfo.base_delivery_price +
          orderInfo.room_tip
      : cartPay.total_amount_incl - discount.discountAmount
  );

  const [paymentUrl, setPaymentUrl] = useState<string>("");
  const [isOpenPay, setIsOpenPay] = useState<boolean>(false);

  const onCloseClosedConfirm = (value: boolean) => {
    setVisibleClosed(value);
    AsyncLocalStorage.removeItem("cart");
    navigate("/master");
  };

  const onPay = () => {
    if (selectedCard === -1) {
      showToast("카드를 선택해주세요.", "error");
    } else {
      navigate("/password", {
        state: {
          ccard: cardList.data ? cardList.data[selectedCard] : undefined,
          order_data: orderResult,
        },
      });
    }
  };

  const handleCheckboxToggle = (checkboxNumber: number) => {
    if (checkboxNumber === 1) {
      setRequestChecked1(!requestChecked1);
    } else if (checkboxNumber === 2) {
      setRequestChecked2(!requestChecked2);
    }
  };
  const handleCouponCodeChange = (event: any) => {
    setCouponCode(event.target.value);
  };
  const handleTextareaChange = (event: any) => {
    const inputText = event.target.value;
    if (inputText.length <= 80) {
      setRequestText(inputText);
    } else {
      showToast(langText.paymentListModal_toast_exceed[lang], "error"); //d
    }
  };

  const startEvent = async () => {
    const eventData = await getEventList();

    if (eventData && eventData.used === 0) {
      openEvent(eventData);
    }
  };
  const openEvent = (eventData: EventType) => {
    LogController.click({
      path: "PaymentListModal",
      params: "event",
      params2: "틀린그림찾기 이벤트 클릭",
    });

    setRecoil(eventState, {
      ...eventData,
      visible: true,
      coupon: null,
    });
  };
  const getEventList = async () => {
    const user_id = getRecoil(qrAuthState).user_id;
    const user_token_id = getRecoil(qrAuthState).user_token_id;

    try {
      const response = await ApiController.store.getEventList(
        user_id,
        user_token_id
      );

      if (response && response.data) {
        const oRes = response.data;
        const eventData = oRes.data.find(
          (item: EventType) => item.event_type === 2
        );
        return eventData || null;
      }
    } catch (err) {
      console.log("getAdverList err-->", err);
    }
  };

  const checkLogin = () => {
    if (auth.phone_number === null) {
      setVisibleAuthentication(true);
    } else {
      setVisibleCardList(true);
    }
  };

  const openAddCardModal = () => {
    setVisibleCardList(false);
    setVisibleAddCard(true);
  };

  const onAuthenticate = () => {
    setVisibleAuthentication(false);
    setVisibleCardList(true);
  };

  const closeAddCardModal = () => {
    setVisibleAddCard(false);
    setVisibleCardList(true);
  };

  const closePay = () => {
    setIsOpenPay(false);
    setPaymentUrl("");
  };

  const RenderHeader = () => {
    return (
      <div className="modalHeader">
        <h3>{langText.paymentListModal_title_name[lang]}</h3>
        <img
          className="backIcon"
          onClick={() => {
            navigate(-1);
          }}
          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_left.svg`}
          alt="back"
        />
      </div>
    );
  };

  const RenderPaymentHeader = () => {
    return (
      <div className="modalHeader">
        <h3>{langText.payment_title_pay[lang]}</h3>
        <img
          className="backIcon"
          onClick={closePay}
          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_left.svg`}
          alt="back"
        />
      </div>
    );
  };

  const RenderPaymentList = () => {
    return (
      <div className={`paymentListWrap ${onKeyboard && "input"}`}>
        {cart.map((product, index) => (
          <div key={index} className="menuContent">
            <div className="orderIndex">
              <p>{index + 1}</p>
            </div>
            <div className="orderTitle">
              <div className="menuTitleWrap">
                <div className="menuNameWrap">
                  <div
                    className={
                      product.product_discount_amount > 0
                        ? "menuNameShot"
                        : "menuName"
                    }
                  >
                    <h3>{getProductName(product, lang)}</h3>
                  </div>
                  {product.product_discount_amount > 0 && (
                    <div className="badge">
                      <h3>
                        {product.prdouct_discount_percentage}%{" "}
                        {langText.discount[lang]}
                      </h3>
                    </div>
                  )}
                </div>
                {product.options?.map((option, index) => (
                  <div key={index} className="orderOption">
                    <img
                      src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_lineBreak.svg`}
                      alt="옵션아이콘"
                    />
                    <div className="optionCategory">
                      <span>&#91;</span>
                      <p className="optionCategoryName">
                        {getOptionTypeName(option, lang)}
                      </p>
                      <span>&#93;</span>
                    </div>
                    <p className="optionName">{getOptionName(option, lang)}</p>
                    {/* <p className="optionPrice">
                    {option.option_price.toLocaleString()}원
                  </p> */}
                  </div>
                ))}
                {product.set_product.map((set_product, prd_group_index) => (
                  <div className="optionLine">
                    <img
                      src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_lineBreak.svg`}
                      alt="옵션아이콘"
                    />

                    {set_product.input_min > 0 ? (
                      <p className="optionCategoryName">
                        [{langText.setOptionModal_configuration[lang]}
                        {prd_group_index + 1}]
                      </p>
                    ) : (
                      <p className="optionCategoryName">
                        [{langText.setOptionModal_addtional[lang]}]
                      </p>
                    )}
                    <div className="optionCategory">
                      {set_product.pick.map((pickProduct, prd_index) => (
                        <div className="setOrderOption" key={prd_index}>
                          <p>{getPrdName(pickProduct, lang)}</p>
                          {pickProduct.pick.length > 0 && (
                            <div className="optionBreak">
                              <div className="optionBreakLine"></div>
                              <h5>({langText.setOptionModal_option[lang]})</h5>
                            </div>
                          )}
                          {pickProduct.pick.map((pickOptionGroup, index) =>
                            pickOptionGroup.map((pickOption, opt_index) => (
                              <span key={opt_index}>
                                {getOptionName(
                                  pickProduct.option_group_list[index]
                                    ?.option_list[pickOption],
                                  lang
                                )}
                              </span>
                            ))
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
              <div>
                <h3 className="menuPrice">
                  {product.product_total_amount.toLocaleString()}원
                </h3>
                <div className="menuCount">
                  <img
                    onClick={() => {
                      OrderController.updateCartRecoilproductQuantityByIndex(
                        index,
                        false,
                        showToast
                      );
                    }}
                    src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_minus.svg`}
                    alt="minus"
                  />
                  <h4>{product.product_quantity}</h4>
                  <img
                    onClick={() => {
                      OrderController.updateCartRecoilproductQuantityByIndex(
                        index,
                        true,
                        showToast
                      );
                    }}
                    src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_plus.svg`}
                    alt="plus"
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
        <ConfirmModal
          isVisible={visibleConfirm}
          setVisible={setVisibleConfirm}
          title={langText.confirmModal_cancelPayment[lang]}
          confirmText={langText.button_yes[lang]}
          cancelText={langText.button_no[lang]}
          onConfirm={() => {
            try {
              LogController.click({
                path: "PaymentListModal",
                params: "click",
                params2: `결제취소 클릭`,
                store_id:
                  getRecoil(cartState).length > 0
                    ? getRecoil(cartState)[0].store_id
                    : 0,
                index:
                  getRecoil(cartState).length > 0
                    ? getRecoil(cartState)[0].store_id
                    : 0,
              });
            } catch (err) {
              console.log(err);
            }
            window.ReactNativeWebView?.postMessage(
              MessageController.getOrderCompleteData()
            );
            setVisibleConfirm(false);
            startEvent();
          }}
        />
        <ConfirmModal
          isVisible={visibleClosed}
          setVisible={onCloseClosedConfirm}
          title={langText.confirmModal_closed[lang]}
          confirmText={langText.button_home[lang]}
        />
      </div>
    );
  };

  const sendOrder = async (
    paymentMethod: number,
    number?: string,
    email?: string,
    card_name?: string
  ) => {
    let res = await ApiController.store.getStoreWebOrderData(
      auth.user_id,
      cart[0].store_id,
      master.store_id,
      auth.user_token_id,
      cartPay.total_amount_incl,
      auth.area_id,
      auth.room_id
    );
    if (res.ok) {
      let deliveryInfo: {
        address1: string;
        address2: string;
        area_number: number;
        number: number;
        area_name: string;
        name: string;
        store_id: number;
        limit_order_price: number;
        max_delivery_distance: number;
        base_delivery_price: number;
        base_delivery_distance: number;
        surcharge_delivery_distance: number;
        surcharge_delivery_price: number;
        is_self_delivery: number;
        delivery_call_type: number;
        delivery_estimated_time: number;
        delivery_prepare_time: number;
        pickup_name: string;
        pickup_name_en: string;
        room_tip: number;
        coupon_list: {
          availble_coupon_list: CouponType[];
          unavailable_coupon_list: CouponType[];
        };
      } = res.data;

      console.log(
        "textarea currnet",
        textareaRef.current,
        textareaRef.current ? textareaRef.current.value : null
      );

      console.log("realPayPrice", realPayPrice);

      if (realPayPrice >= 500 || realPayPrice === 0) {
        let oRes = await OrderController.sendOrder(
          cart,
          storeName,
          cartPay,
          textareaRef.current ? textareaRef.current.value : "",
          deliveryInfo,
          discount,
          paymentMethod,
          cart[0].product_type === PRODUCT_TYPE_RENTAL_SMS &&
            number &&
            number.length > 0
            ? number
            : undefined,
          cart[0].product_type === PRODUCT_TYPE_RENTAL_SMS &&
            email &&
            email.length > 0
            ? email
            : undefined,
          lang === LANG_KO ? undefined : card_name
        );
        console.log("oRes", oRes);
        if (oRes.ok) {
          setOrderResult(oRes);
          if (oRes.complete) {
            navigate("/status");
            showToast(langText.payment_completed[lang], "success", 3000);
            setTimeout(() => {
              setRecoil(cartState, []);
              AsyncLocalStorage.removeItem("cart");
            }, 100);
          } else {
            if (paymentMethod !== CARD_METHOD) {
              // const linkUrl = `${process.env.REACT_APP_API_URL}/pay/nice/${
              //   oRes.order_id
              // }/${oRes.order_seq}${lang === LANG_KO ? "" : `/${lang}`}${
              //   card_name ? `/${card_name}` : `/normal`
              // }`;
              // const left = (window.innerWidth - 1000) / 2;
              // const top = (window.innerHeight - 500) / 2;
              onMessageEvent();
              setPaymentUrl(
                `${process.env.REACT_APP_API_URL}/pay/nice/${oRes.order_id}/${
                  oRes.order_seq
                }${lang === LANG_KO ? "" : `/${lang}`}${
                  card_name ? `/${card_name}` : `/normal`
                }`
              );
              setIsOpenPay(true);
              // setTimeout(() => {
              //   oWindow = window.open(
              //     linkUrl,
              //     "_blank",
              //     `width=${540}, height=${850}, left=${left}, top=${top} location=no,directories=no, resizable=no, status=no, toolbar=no, menubar=no, scrollbars=no`
              //   );
              // }, 50);
            } else {
              checkLogin();
            }
          }
        } else {
          showToast(langText.payment_error[lang], "error");
        }
      } else {
        showToast(langText.payment_not_minimum[lang], "error");
      }
    }
  };

  const setData = async (store_id: number) => {
    const price = cartPay.total_amount_incl;

    let res = await ApiController.store.getStoreWebOrderData(
      auth.user_id,
      store_id,
      master.store_id,
      auth.user_token_id,
      price,
      auth.area_id,
      auth.room_id
    );

    if (res.ok) {
      const orderData: StoreOrderType = res.data;
      // showToast(`${orderData.store_availability}`);
      if (!orderData.store_availability_yn) {
        setVisibleClosed(true);
      }
      setOrderInfo(orderData);
      console.log("orderData", orderData, cart);
      if (orderData.coupon_list.availble_coupon_list.length > 0) {
        setCouponList([...orderData.coupon_list.availble_coupon_list]);
        setVisibleCouponList([...orderData.coupon_list.availble_coupon_list]);
      } else {
        setCouponList([]);
        setVisibleCouponList([]);
      }

      setUnavailableCouponList([
        ...orderData.coupon_list.unavailable_coupon_list,
      ]);
      setIsLoading(false);
    }
  };

  const onClickPayment = (paymentMethod: number, card_name?: string) => {
    if (cart[0].product_type === PRODUCT_TYPE_RENTAL_SMS) {
      setVisibleCustomerInfoModal({
        visible: true,
        method: paymentMethod,
        card_name,
      });
    } else {
      doPayment(paymentMethod, undefined, undefined, card_name!);
    }
  };

  const doPayment = async (
    paymentMethod: number,
    number?: string,
    email?: string,
    card_name?: string
  ) => {
    if (cart.length > 0 && !isOrder && !isLoading) {
      setIsOrder(true);
      if (orderInfo.limit_order_price > cartPay.total_amount_incl) {
        showToast(
          `${
            lang === LANG_KO || lang === LANG_JP
              ? `${orderInfo.limit_order_price.toLocaleString()}원`
              : ""
          }${langText.paymentListModal_button_order_limit[lang]} ${
            lang === LANG_EN || lang === LANG_CH || lang === LANG_TH
              ? `${orderInfo.limit_order_price.toLocaleString()}원`
              : ""
          }`,
          "error"
        );

        try {
          LogController.click({
            path: "PaymentListModal",
            params: "click",
            params2: `${
              paymentMethod === PG_METHOD
                ? "PG"
                : paymentMethod === CARD_METHOD
                ? "카드"
                : "해외결제"
            }최소주문금액 미달 => 구매금액: ${
              cartPay.total_amount_incl
            }, 최소주문금액: ${orderInfo.limit_order_price}`,
            store_id: cart.length > 0 ? cart[0].store_id : 0,
            index: cartPay.total_amount_incl,
          });
        } catch (err) {
          console.log(err);
        }
        return;
      }

      if (cartPay.total_amount_incl >= orderInfo.limit_order_price) {
        try {
          LogController.click({
            path: "PaymentListModal",
            params: "click",
            params2: `${
              paymentMethod === PG_METHOD
                ? "PG"
                : paymentMethod === CARD_METHOD
                ? "카드"
                : "해외결제"
            }결제하기클릭 => 구매금액: ${cartPay.total_amount_incl}`,
          });
        } catch (err) {
          console.log(err);
        }
      }
      sendOrder(paymentMethod, number, email, card_name!);
    }
  };

  const onMessageEvent = () => {
    if (addedListeners["message"]) {
      return;
    }
    addedListeners["message"] = true;
    window.addEventListener("message", (event) => {
      console.log("event", event);

      if (event.data && typeof event.data === "string") {
        if (!event.data.includes("webpack")) {
          if (event.data === "close") {
            setIsOpenPay(false);
            setPaymentUrl("");
          } else {
            const parsed = JSON.parse(event.data);
            console.log("success", parsed);
            if (parsed.success) {
              navigate("/status");
              // oWindow!.close();
              setIsOpenPay(false);
              setPaymentUrl("");
              addedListeners = {};
              window.removeEventListener("message", () => {});
              showToast(langText.payment_completed[lang], "success", 3000);
              setTimeout(() => {
                setRecoil(cartState, []);
                AsyncLocalStorage.removeItem("cart");
              }, 100);
            }
          }
        }
      }
    });
  };

  useEffect(() => {
    onMessageEvent();
  }, []);

  useEffect(() => {
    if (isOrder) {
      setTimeout(() => {
        setIsOrder(false);
      }, 1500);
    }
  }, [isOrder]);

  useEffect(() => {
    if (cart.length < 1) {
      navigate(-1);
    } else {
      setData(cart[0].store_id);
    }
  }, [cart]);

  React.useEffect(() => {
    setRealPayPrice(
      cart.length > 0 && cart[0].product_type === PRODUCT_TYPE_DELIVERY
        ? cartPay.total_amount_incl -
            discount.discountAmount +
            orderInfo.base_delivery_price +
            orderInfo.room_tip
        : cartPay.total_amount_incl - discount.discountAmount
    );
  }, [cartPay, discount, orderInfo]);

  // 쿠폰 로직
  useEffect(() => {
    let hqList: { description: string; discount: number }[] = [];
    let storeList: { description: string; discount: number }[] = [];
    let discount = 0;
    let storeDiscount = 0;
    let hqDiscount = 0;
    const price = cartPay.total_amount_incl;
    let totalPrice = cartPay.total_amount_incl;
    let applyCoupons: (CouponType & {
      store_discount_amount: number;
      com_discount_amount: number;
    })[] = [];
    for (let coupon of couponList) {
      let com_discount_amount = 0;
      let store_discount_amount = 0;
      if (coupon.coupon_type === 0) {
        //정액할인

        //매장부담
        if (coupon.partner_discount > 0) {
          if (totalPrice - coupon.partner_discount <= 0) {
            storeList.push({
              description: coupon.coupon_name + " 할인",
              discount: totalPrice,
            });
            discount += totalPrice;
            storeDiscount += totalPrice;
            store_discount_amount += totalPrice;
            totalPrice = 0;
            applyCoupons.push({
              ...coupon,
              com_discount_amount,
              store_discount_amount,
            });
            break;
          } else {
            storeList.push({
              description: coupon.coupon_name + " 할인",
              discount: coupon.partner_discount,
            });
            discount += coupon.partner_discount;
            storeDiscount += coupon.partner_discount;
            store_discount_amount += coupon.partner_discount;
            totalPrice -= coupon.partner_discount;
          }
        }
        //본사부담
        if (coupon.hq_discount > 0) {
          if (totalPrice - coupon.hq_discount <= 0) {
            hqList.push({
              description: coupon.coupon_name + " 할인",
              discount: totalPrice,
            });
            discount += totalPrice;
            hqDiscount += totalPrice;
            com_discount_amount += totalPrice;
            applyCoupons.push({
              ...coupon,
              com_discount_amount,
              store_discount_amount,
            });
            totalPrice = 0;
            break;
          } else {
            hqList.push({
              description: coupon.coupon_name + " 할인",
              discount: coupon.hq_discount,
            });
            discount += coupon.hq_discount;
            hqDiscount += coupon.hq_discount;
            com_discount_amount += coupon.hq_discount;
            totalPrice -= coupon.hq_discount;
          }
        }
      } else if (coupon.coupon_type === 1) {
        //정률할인

        //할인금액
        let priceDc = Math.floor((price * coupon.percent) / 100);

        //할인금액이 최대할인금액 보다 클경우 조정.
        if (priceDc > coupon.max_discount) {
          priceDc = coupon.max_discount;
        }

        //사장님 부담 할인금액
        const partnerDc = Math.floor((priceDc * coupon.partner_percent) / 100);
        //본사부담 할인금액
        const hqDc = priceDc - partnerDc;

        if (partnerDc > 0) {
          if (totalPrice - partnerDc <= 0) {
            storeList.push({
              description: coupon.coupon_name + " 할인",
              discount: totalPrice,
            });
            discount += totalPrice;
            storeDiscount += totalPrice;
            store_discount_amount += totalPrice;
            totalPrice = 0;
            applyCoupons.push({
              ...coupon,
              com_discount_amount,
              store_discount_amount,
            });
            break;
          } else {
            storeList.push({
              description: coupon.coupon_name + " 할인",
              discount: partnerDc,
            });
            discount += partnerDc;
            storeDiscount += partnerDc;
            store_discount_amount += partnerDc;
            totalPrice -= partnerDc;
          }
        }

        if (hqDc > 0) {
          if (totalPrice - hqDc <= 0) {
            hqList.push({
              description: coupon.coupon_name + " 할인",
              discount: totalPrice,
            });
            discount += totalPrice;
            hqDiscount += totalPrice;
            totalPrice -= totalPrice;
            com_discount_amount += totalPrice;
            applyCoupons.push({
              ...coupon,
              com_discount_amount,
              store_discount_amount,
            });
            break;
          } else {
            hqList.push({
              description: coupon.coupon_name + " 할인",
              discount: hqDc,
            });
            discount += hqDc;
            hqDiscount += hqDc;
            totalPrice -= hqDc;
            com_discount_amount += hqDc;
          }
        }
      } else if (coupon.coupon_type === 2) {
        if (coupon.price > 0) {
          //정액할인
          if (coupon.partner_discount > 0) {
            if (totalPrice - coupon.partner_discount <= 0) {
              storeList.push({
                description: coupon.coupon_name + " 쿠폰코드 할인",
                discount: totalPrice,
              });
              discount += totalPrice;
              storeDiscount += totalPrice;
              store_discount_amount += totalPrice;
              totalPrice = 0;
              applyCoupons.push({
                ...coupon,
                com_discount_amount,
                store_discount_amount,
              });
              break;
            } else {
              storeList.push({
                description: coupon.coupon_name + " 쿠폰코드 할인",
                discount: coupon.partner_discount,
              });
              discount += coupon.partner_discount;
              storeDiscount += coupon.partner_discount;
              store_discount_amount += coupon.partner_discount;
              totalPrice -= coupon.partner_discount;
            }
          }
          //본사부담
          if (coupon.hq_discount > 0) {
            if (totalPrice - coupon.hq_discount <= 0) {
              hqList.push({
                description: coupon.coupon_name + " 쿠폰코드 할인",
                discount: totalPrice,
              });
              discount += totalPrice;
              hqDiscount += totalPrice;
              com_discount_amount += totalPrice;
              applyCoupons.push({
                ...coupon,
                com_discount_amount,
                store_discount_amount,
              });
              totalPrice = 0;
              break;
            } else {
              hqList.push({
                description: coupon.coupon_name + " 쿠폰코드 할인",
                discount: coupon.hq_discount,
              });
              discount += coupon.hq_discount;
              hqDiscount += coupon.hq_discount;
              com_discount_amount += coupon.hq_discount;
              totalPrice -= coupon.hq_discount;
            }
          }
        } else if (coupon.percent > 0) {
          //정률할인
          //할인금액
          let priceDc = Math.floor((price * coupon.percent) / 100);

          //할인금액이 최대할인금액 보다 클경우 조정.
          if (priceDc > coupon.max_discount) {
            priceDc = coupon.max_discount;
          }

          //사장님 부담 할인금액
          const partnerDc = Math.floor(
            (priceDc * coupon.partner_percent) / 100
          );
          //본사부담 할인금액
          const hqDc = priceDc - partnerDc;

          if (partnerDc > 0) {
            if (totalPrice - partnerDc <= 0) {
              storeList.push({
                description: coupon.coupon_name + " 쿠폰코드 할인",
                discount: totalPrice,
              });
              discount += totalPrice;
              storeDiscount += totalPrice;
              store_discount_amount += totalPrice;
              totalPrice = 0;
              applyCoupons.push({
                ...coupon,
                com_discount_amount,
                store_discount_amount,
              });
              break;
            } else {
              storeList.push({
                description: coupon.coupon_name + " 쿠폰코드 할인",
                discount: partnerDc,
              });
              discount += partnerDc;
              storeDiscount += partnerDc;
              store_discount_amount += partnerDc;
              totalPrice -= partnerDc;
            }
          }

          if (hqDc > 0) {
            if (totalPrice - hqDc <= 0) {
              hqList.push({
                description: coupon.coupon_name + " 쿠폰코드 할인",
                discount: totalPrice,
              });
              discount += totalPrice;
              hqDiscount += totalPrice;
              totalPrice -= totalPrice;
              com_discount_amount += totalPrice;
              applyCoupons.push({
                ...coupon,
                com_discount_amount,
                store_discount_amount,
              });
              break;
            } else {
              hqList.push({
                description: coupon.coupon_name + " 쿠폰코드 할인",
                discount: hqDc,
              });
              discount += hqDc;
              hqDiscount += hqDc;
              totalPrice -= hqDc;
              com_discount_amount += hqDc;
            }
          }
        }
      }

      applyCoupons.push({
        ...coupon,
        com_discount_amount,
        store_discount_amount,
      });
    }

    setDiscount({
      discountAmount: discount,
      storeDiscountAmount: storeDiscount,
      hqDiscountAmount: hqDiscount,
      storeDiscountList: storeList,
      hqDiscountList: hqList,
      couponList: applyCoupons,
    });
  }, [couponList]);

  // custom TextArea

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault(); // Enter 키의 기본 동작을 막음 (예: 줄 바꿈)
      if (textareaRef.current) {
        textareaRef.current.blur(); // 포커스를 제거하여 키보드를 닫습니다.
      }
    }
  };
  const CustomTextarea: React.FC<any> = (props) => {
    return <textarea {...props} />;
  };

  const onClickCouponCode = async () => {
    const res = await ApiController.store.getCouponCode({
      store_id: cart[0].store_id,
      parent_store_id: master.store_id,
      user_token_id: auth.user_token_id,
      price: cartPay.total_amount_incl,
      coupon_code: couponCode,
    });

    console.log(res.data);

    if (res.ok && res.data.length > 0) {
      const couponCodeList: CouponType[] = res.data;
      let availableCoupons: CouponType[] = [
        ...couponList.filter(
          (coupon) => coupon.coupon_type !== 2 && coupon.duplicate_user !== 1
        ),
      ];

      let visibleCoupons: CouponType[] = [
        ...visibleCouponList.filter(
          (coupon) => coupon.coupon_type !== 2 && coupon.duplicate_user !== 1
        ),
      ];

      // let unavailableCoupons: CouponType[] = unavailableCouponList;

      let dupleCoupon: CouponType[] = [
        ...couponList.filter(
          (coupon) => coupon.coupon_type !== 2 && coupon.duplicate_user === 1
        ),
      ];

      for (let i = 0; i < dupleCoupon.length; i++) {
        const dc = dupleCoupon[i];
        visibleCoupons.push(dc);
      }

      for (let coupon of couponCodeList) {
        if (coupon.requirement > cartPay.total_amount_incl) {
          showToast(
            `${langText.coupon_name[lang]} ${
              langText.menuInfo_base_delivery_price[lang]
            } ${coupon.requirement.toLocaleString()}원`,
            "error"
          );
          return;
        }

        availableCoupons.push(coupon);
        visibleCoupons.push(coupon);
      }

      if (couponList.filter((coupon) => coupon.coupon_type === 2).length > 0)
        showToast(
          langText.paymentListModal_toast_already_coupon[lang],
          "error"
        );
      else {
        showToast(langText.paymentListModal_toast_add_coupon[lang]);
      }

      setCouponList(availableCoupons);
      setVisibleCouponList(visibleCoupons);
    } else {
      showToast(
        langText.paymentListModal_toast_coupon_code_error[lang],
        "error"
      );
    }
  };

  return (
    <>
      <Style>
        {isOpenPay ? (
          <div className="paymentModalWrap">
            <RenderPaymentHeader />
            <iframe src={paymentUrl} title="nice_pay" />
          </div>
        ) : (
          <div className="paymentModalWrap">
            <RenderHeader />
            <div className="badge delivery">
              <h3>{langText.paymentListModal_title_pickup_location[lang]}</h3>
              <h3>⮕</h3>
              <h3 className="pickupName">
                {lang === 0 ? orderInfo.pickup_name : orderInfo.pickup_name_en}
              </h3>
            </div>
            <RenderPaymentList />
            {/* 요청사항 */}
            <div className="orderRequest">
              <h3>{langText.paymentListModal_title_request[lang]}</h3>
              <textarea
                onKeyDown={handleKeyDown}
                ref={textareaRef}
                placeholder={langText.paymentListModal_placeholder[lang]}
                value={requestText}
                onFocus={() => setOnKeyboard(true)}
                onBlur={() => setOnKeyboard(false)}
                onChange={handleTextareaChange}
              />
            </div>
            <div className="totalWrap">
              <div className="totalContent">
                <h3>{langText.paymentListModal_title_productPrice[lang]}</h3>
                <h3>{cartPay.total_amount_org.toLocaleString()}원</h3>
              </div>
              {/* <div className="totalContent">
              <h2>{langText.paymentListModal_title_orderAmount[lang]}</h2>
              <h3>{cartPay.total_amount_incl.toLocaleString()}원</h3>
            </div> */}
              <div className="totalContent">
                <h3>{langText.paymentListModal_title_delivery_cost[lang]}</h3>
                <h3>{orderInfo.base_delivery_price.toLocaleString()}원</h3>
              </div>
              {/* TODO 번역  */}
              {orderInfo.room_tip > 0 && (
                <div className="totalContent">
                  <h3>{langText.room_tip[lang]}</h3>
                  <h3>{orderInfo.room_tip.toLocaleString()}원</h3>
                </div>
              )}
              <div className="totalContent coupon">
                <h3>{langText.paymentListModal_title_coupon[lang]}</h3>
                <div className="row gap">
                  <input
                    value={couponCode}
                    onChange={handleCouponCodeChange}
                    placeholder={langText.paymentListModal_coupon_code[lang]}
                  />
                  <button onClick={onClickCouponCode}>
                    <h4>{langText.button_confirm[lang]}</h4>
                  </button>
                </div>
              </div>
              {/* 할인금액 */}
              <div>
                {(discount.discountAmount + cartPay.discount_amount > 0 ||
                  visibleCouponList.length > 0) && (
                  <div className="totalContent">
                    <div className="row gap">
                      <h3>{langText.paymentListModal_title_discount[lang]}</h3>
                      <div className="badge">
                        <h3>
                          {langText.paymentListModal_maximum_discount[lang]} 🎉
                        </h3>
                      </div>
                    </div>
                    <h3>
                      {discount.discountAmount + cartPay.discount_amount > 0
                        ? `-${(
                            discount.discountAmount + cartPay.discount_amount
                          ).toLocaleString()}원`
                        : `0원`}
                    </h3>
                  </div>
                )}

                <div className="couponWrap">
                  {(discount.discountAmount + cartPay.discount_amount > 0 ||
                    visibleCouponList.length > 0) && (
                    <div>
                      {cartPay.discount_amount > 0 && (
                        <div className="totalContent discount">
                          <div className="row gap">
                            <img
                              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_lineBreak.svg`}
                              alt="옵션아이콘"
                            />
                            <h4>
                              {
                                langText
                                  .paymentListModal_title_product_discount[lang]
                              }
                            </h4>
                          </div>
                          <h4>-{cartPay.discount_amount.toLocaleString()}원</h4>
                        </div>
                      )}
                      {visibleCouponList.length > 0 && (
                        <div className="totalContent discount coupon">
                          <div className="row gap">
                            <img
                              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_lineBreak.svg`}
                              alt="옵션아이콘"
                            />
                            <h4>
                              {
                                langText.paymentListModal_title_coupon_discount[
                                  lang
                                ]
                              }
                            </h4>
                          </div>
                          <div className="couponListWrap">
                            {visibleCouponList.map((item, index: number) => {
                              const discountCoupon = discount.couponList.find(
                                (obj) => obj.coupon_id === item.coupon_id
                              );
                              return (
                                <div key={index} className="discountInfo">
                                  <div className="couponName">
                                    <h4>•{item.coupon_name}</h4>
                                  </div>
                                  <div className="row">
                                    {discountCoupon && (
                                      <h4>
                                        -
                                        {(
                                          discountCoupon.com_discount_amount +
                                          discountCoupon.store_discount_amount
                                        ).toLocaleString()}
                                        원
                                      </h4>
                                    )}
                                    <button
                                      className="checkBox"
                                      onClick={() => {
                                        if (discountCoupon) {
                                          //쿠폰이 있는경우
                                          const coupons = [
                                            ...couponList.filter(
                                              (c) =>
                                                c.coupon_id !== item.coupon_id
                                            ),
                                          ];
                                          setCouponList(coupons);
                                        } else {
                                          if (item.duplicate_user === 1) {
                                            const coupons = couponList.filter(
                                              (c) => c.duplicate_user !== 1
                                            );
                                            coupons.push(item);
                                            setCouponList(coupons);
                                          } else {
                                            const coupons = [
                                              ...couponList,
                                              item,
                                            ];
                                            setCouponList(coupons);
                                          }
                                        }
                                      }}
                                    >
                                      {discountCoupon && (
                                        <img
                                          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_check_mint.svg`}
                                          alt="체크박스"
                                        />
                                      )}
                                    </button>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  {/* 사용불가쿠폰 */}
                  {unavailableCouponList.length > 0 && (
                    <div className="totalContent discount coupon unavailable">
                      {unavailableCouponList.map((item, index: number) => (
                        <div key={index} className="discountInfo unavailable">
                          <div className="couponName">
                            <h4>•{item.coupon_name}</h4>
                          </div>
                          <div className="unavailableNotive">
                            {item.requirement.toLocaleString()}
                            {langText.paymentListModal_unavailable_notice[lang]}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* 총결제금액 */}
            <div className="totalOrder">
              <h3>{langText.paymentListModal_title_totalPayment[lang]}</h3>
              <h3 className="quantity">{cartQuantitiy}</h3>
              <h3>
                {realPayPrice >= 0 ? realPayPrice.toLocaleString() : `0`}원
              </h3>
            </div>
            <div className="modalFooter">
              <button
                className={`${lang === LANG_KO ? "normal" : "easy"} ${
                  cartPay.total_amount_incl < orderInfo.limit_order_price &&
                  "unabled"
                }`}
                onClick={() =>
                  onClickPayment(lang === LANG_KO ? PG_METHOD : FOREIGN_METHOD)
                }
              >
                <h2>{langText.paymentListModal_button_pay_normal[lang]}</h2>
              </button>
              {lang === LANG_KO ? (
                <button
                  className={`easy ${
                    cartPay.total_amount_incl < orderInfo.limit_order_price &&
                    "unabled"
                  }`}
                  onClick={() => onClickPayment(CARD_METHOD)}
                >
                  <h2>{langText.paymentListModal_button_pay_easy[lang]}</h2>
                </button>
              ) : (
                <div className="foreignWrap">
                  <button
                    onClick={() => onClickPayment(PG_METHOD, CARD_NAME_VISA)}
                  >
                    <img
                      src={`${process.env.PUBLIC_URL}/knockknock/img/visa_card.png`}
                      alt="visa"
                    />
                  </button>
                  <button
                    onClick={() => onClickPayment(PG_METHOD, CARD_NAME_MASTER)}
                  >
                    <img
                      src={`${process.env.PUBLIC_URL}/knockknock/img/master_card.png`}
                      alt="visa"
                    />
                  </button>
                  <button
                    onClick={() => onClickPayment(PG_METHOD, CARD_NAME_UNION)}
                  >
                    <img
                      src={`${process.env.PUBLIC_URL}/knockknock/img/union_pay.png`}
                      alt="visa"
                    />
                  </button>
                  <button
                    onClick={() => onClickPayment(PG_METHOD, CARD_NAME_JBC)}
                  >
                    <img
                      src={`${process.env.PUBLIC_URL}/knockknock/img/jbc_card.png`}
                      alt="visa"
                    />
                  </button>
                </div>
              )}
              {/* <div className="row">
              <p>{langText.paymentListModal_comment_easy[lang]}</p>
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_coin.svg`}
                alt="coin"
              />
            </div> */}
            </div>
          </div>
        )}
      </Style>
      <AuthenticationModal
        isVisible={visibleAuthentication}
        setVisible={setVisibleAuthentication}
        onAuthenticate={onAuthenticate}
      />
      <CardListModal
        isVisible={visibleCardList}
        setVisible={setVisibleCardList}
        openAddCardModal={openAddCardModal}
        cardList={cardList}
        selectedCard={selectedCard}
        setSelectedCard={setSelectedCard}
        onPay={onPay}
      />
      <AddCardModal isVisible={visibleAddCard} setVisible={closeAddCardModal} />
      <CustomerInfoModal
        isVisible={visibleCustomerInfoModal}
        setVisible={setVisibleCustomerInfoModal}
        doPayment={doPayment}
        isVoucher={false}
      />
    </>
  );
};

export default Payment;

const Style = styled.div`
  .paymentModalWrap {
    width: 100vw;
    height: 100%;
    min-height: 100dvh;
    display: flex;
    flex-direction: column;
  }

  iframe {
    background: #fff;
    height: calc(100dvh - 70px);
  }

  .badge {
    padding: 2px 8px;
    border-radius: 50px;
    background: linear-gradient(90deg, #4ed2af 0%, #90c2e6 100%);
    h3 {
      white-space: nowrap;
      font-size: 12px;
      line-height: 14px;
      font-weight: 600;
      color: #fff;
    }
  }
  .badge.delivery {
    width: min-content;
    max-width: 80%;
    padding: 2px 12px;
    display: flex;
    align-items: center;
    background: #ff6262;
    gap: 4px;
    border-radius: 50px;
    margin: 0 10px 10px auto;

    h3 {
      font-size: 14px;
      line-height: 20px;
      font-weight: 500;
    }
    h3.pickupName {
      width: max-content;
      white-space: normal;
      word-break: break-all;
    }
  }
  .row {
    display: flex;
    align-items: center;
  }
  .row.gap {
    gap: 6px;
  }

  /* modalHeader */
  .modalHeader {
    /* display: flex;
    align-items: center;
    justify-content: space-between; */
    padding: 20px 10px;
    text-align: center;
    position: relative;

    h3 {
      font-weight: 500;
    }

    button {
      padding: 0;
    }

    .backIcon {
      position: absolute;
      left: 4px;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  /* paymentListWrap */
  .paymentListWrap {
    width: 100%;
    min-height: 30vh;
    max-height: 50vh;
    flex: 1;
    padding: 0 10px;
    overflow-y: auto;
    background: #111111;
  }

  /* paymentContentWrap */
  .paymentContentWrap {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .menuContent {
    width: 100%;
    padding: 10px 0;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    border-bottom: 1px solid #282828;

    .orderIndex {
      margin-right: 10px;
      border: 1px solid #555555;
      border-radius: 4px;

      p {
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #e5e5e5;
        font-size: 12px;
        line-height: 12px;
        font-weight: 300;
      }
    }
  }

  /* orderList */

  .orderTitle {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;

    h3 {
      font-size: 16px;
      line-height: 24px;
    }
  }
  .orderMenu,
  .orderOption {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .orderOption {
    margin: 4px 0;
    justify-content: flex-start;

    p {
      font-size: 12px;
      font-weight: 300;
      color: #e5e5e5;
    }

    .optionCategory {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin: 0 5px;

      span {
        font-size: 12px;
      }
      p {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .optionName {
      flex: 0 0 80%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .optionPrice {
      flex: 0 0 23%;
      text-align: right;
      margin-left: auto;
    }
  }
  .menuTitleWrap {
    width: calc(100vw - 150px);
    .menuNameWrap {
      display: flex;
      h3 {
        white-space: normal;
      }
      .badge {
        margin-left: 6px;
        padding: 0;
        background: none;
        h3 {
          font-size: 10px;
          color: #ff6262;
          padding: 0;
        }
      }
    }
  }
  .menuNameShot,
  .menuName {
    display: flex;

    h3 {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .menuNameShot {
    max-width: 60%;
  }
  .menuName {
    max-width: 100%;
    font-weight: 500;
  }
  .menuCount {
    width: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
    h4 {
      line-height: 16px;
      font-weight: 600;
    }
    img {
      width: 22px;
      height: 22px;
    }
  }
  .menuPrice {
    flex: 0 0 25%;
    text-align: right;
    font-weight: 500;
  }

  .optionLine {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 4px 0;

    img {
      padding-top: 2px;
    }

    .optionCategoryName,
    p {
      width: min-content;
      white-space: nowrap;
      margin: 0 4px;
      font-size: 12px;
      line-height: 16px;
      font-weight: 300;
      color: #e5e5e5;
    }
    .optionCategory {
      flex: 1;
    }
  }

  .optionBreak {
    display: flex;
    align-items: center;

    .optionBreakLine {
      border-right: 1px solid #fff;
      margin-right: 4px;
      height: 14px;
    }
    h5 {
      font-size: 12px;
      font-weight: 300;
      color: #e5e5e5;
      white-space: nowrap;
    }
  }
  .setOrderOption {
    display: flex;
    flex-wrap: wrap;
    p {
      width: 100%;
      white-space: normal;
    }
    .optionLineGroup {
      width: 100%;
    }
    span {
      font-size: 12px;
      line-height: 16px;
      font-weight: 300;
      color: #e5e5e5;
      margin-left: 4px;
      margin-bottom: 1px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  /* totalWrap */
  .totalWrap {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px 10px;
    border-bottom: 2px solid #1a1a1a;
  }
  .totalContent,
  .totalOrder {
    display: flex;
    align-items: center;
    justify-content: space-between;

    h2,
    h3 {
      font-weight: 500;
    }
    .badge {
      padding: 2px 6px;
      h3 {
        font-size: 11px;
        line-height: 13px;
      }
    }
  }
  .totalOrder {
    h3 {
      font-weight: 600;
    }
    h3.quantity {
      font-weight: 500;
    }
  }

  /* couponWrap */
  .couponWrap {
    max-height: 135px;
    overflow-y: auto;
  }

  .totalContent.coupon {
    .row.gap {
      gap: 4px;
    }
    input {
      width: 120px;
      padding: 2px 14px;
      border-radius: 5px;
      background: none;
      border: 1px solid #656565;
      font-size: 14px;
      line-height: 26px;
      color: #ffffff;
      text-align: center;
    }
    button {
      border: 1px solid #4dd2ae;
      border-radius: 5px;
      padding: 2px 12px;
      h4 {
        font-size: 14px;
        line-height: 26px;
        color: #4dd2ae;
        white-space: nowrap;
      }
    }
  }

  .totalContent.discount {
    margin-top: 6px;
    /* margin-right: 27px; */
    margin-left: 10%;
    justify-content: space-between;
    align-items: flex-start;

    .row.gap {
      gap: 6px;
    }
    h4 {
      font-size: 13px;
      line-height: 20px;
      font-weight: 500;
      color: #ffffff;
    }
  }
  .totalContent.discount.coupon {
    justify-content: space-between;
    margin: 0;
    margin-left: 10%;

    .couponListWrap {
      display: flex;
      flex-direction: column;
      width: calc(75% - 10px);
      gap: 2px;
    }
    .discountInfo {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .couponName {
      max-width: 70%;
    }
    h4 {
      color: #4dd2ae;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .unavailableNotive {
      font-size: 13px;
      line-height: 20px;
      color: #ff4a4a;
      font-weight: 600;
    }
    .checkBox {
      margin-left: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 22px;
      height: 22px;
      padding: 0;
      border: 1px solid #4dd2ae;
      border-radius: 5px;
    }
  }

  .totalContent.discount.coupon.unavailable {
    display: flex;
    justify-content: space-between;
    flex-direction: column;

    .unavailable {
      width: 100%;
    }
    .unavailable .couponName {
      max-width: 70%;
      h4 {
        color: gray;
      }
    }
  }
  .totalOrder {
    margin: 0;
    padding: 18px 10px;
  }
  .orderRequest {
    padding: 20px 10px;
    border-bottom: 2px solid #1a1a1a;

    h2 {
      font-size: 24px;
      margin: 0;
    }
    h3 {
      margin-bottom: 8px;
      font-weight: 500;
    }
  }

  /* .commentBox {
    padding: 0 14px;
    margin-bottom: 6px;
    background: rgba(64, 151, 127, 0.5);
    border-radius: 50px;
    max-width: 100%;

    p {
      color: #ffffff;
      font-size: 14px;
      line-height: 24px;
      font-weight: 600;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .commentBox:after {
    content: " ";
    height: 0;
    width: 0;
    left: 110px;
    position: absolute;
    border: 5px solid transparent;
    border-bottom-width: 0;
    border-top-color: rgba(64, 151, 127, 0.5);
  } */

  /* orderRequest */
  .orderRequest {
    .requestCheckbox,
    label {
      display: flex;
      align-items: center;
    }
    .requestCheckbox {
      margin: 11px 0 16px 0;
      justify-content: space-between;
    }
    input {
      margin-right: 10px;
      accent-color: #40977f;
    }
    h2 {
      font-size: 22px;
      font-weight: 500;
    }
    span {
      font-size: 16px;
      font-weight: 400;
      color: #e5e5e5;
    }
    textarea {
      width: 100%;
      height: 42px;
      padding: 4px 10px;
      border-radius: 5px;
      background: none;
      border: 1px solid #656565;
      font-size: 14px;
      line-height: 32px;
      color: #ffffff;
    }
  }

  .modalFooter {
    width: 100%;
    padding: 10px;
    padding-bottom: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;

    button {
      width: 100%;
      padding: 12px 0;
      border-radius: 5px;
      h2 {
        font-size: 20px;
        line-height: 28px;
        font-weight: 600;
      }
    }
    button.normal {
      padding: 11px 0;
      border: 1px solid #4dd2ae;
      h2 {
        color: #4dd2ae;
      }
    }
    button.easy {
      background: #4dd2ae;
    }

    .foreignWrap {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 8px;
      button {
        flex: 1;
        max-height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        background: #4dd2ae;
        border-radius: 5px;
        img {
          max-height: 50px;
        }
      }
    }

    .paymentSuccess.unabled {
      background: #cecece;
    }
    .row {
      gap: 4px;
      p {
        font-size: 14px;
        line-height: 20px;
        color: #a7a7a7;
        font-weight: 400;
      }
    }
  }
`;
